import React from "react";
import FileCommentComponent from "../../comments/file-comment";
import { useParams } from "react-router-dom";

const CustomerFileCommentsLits = () => {
  const { id } = useParams();
  return (
    <main>
      <FileCommentComponent tableName={"customer"} viewId={id} />
    </main>
  );
};

export default CustomerFileCommentsLits;
